import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsDriversQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DriverDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DriverDocumentSortInput> | Types.DriverDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsDriversQuery = { __typename?: 'Query', logisticsDrivers?: { __typename?: 'LogisticsDriversConnection', totalCount: number, nodes?: Array<{ __typename?: 'DriverDocument', id: string, tenantId: string, driverId: string, carrierId: string, name: string, phone: string, licenseNumber: string, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsDriverDocumentFieldsFragment = { __typename?: 'DriverDocument', id: string, tenantId: string, driverId: string, carrierId: string, name: string, phone: string, licenseNumber: string, isActive: boolean, updatedAt: Types.TDateISO, updatedBy: string };

export const LogisticsDriverDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDriverDocumentFields on DriverDocument {
  id
  tenantId
  driverId
  carrierId
  name
  phone
  licenseNumber
  isActive
  updatedAt
  updatedBy
}
    `, {"fragmentName":"LogisticsDriverDocumentFields"});
export const GetAllLogisticsDriversDocument = new TypedDocumentString(`
    query GetAllLogisticsDrivers($where: DriverDocumentFilterInput, $order: [DriverDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsDrivers(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsDriverDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsDriverDocumentFields on DriverDocument {
  id
  tenantId
  driverId
  carrierId
  name
  phone
  licenseNumber
  isActive
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsDrivers: build.query<GetAllLogisticsDriversQuery, GetAllLogisticsDriversQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsDriversDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsDriversQuery, useLazyGetAllLogisticsDriversQuery } = injectedRtkApi;
